import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import axios from 'axios';
import config from '../../../config';

const StageUpdateModal = ({ show, handleClose, batchId, stageIndex, stageData, refreshBatch }) => {
  const [formData, setFormData] = useState({
    status: 'pending',
    notes: '',
  });

  useEffect(() => {
    if (stageData) {
      setFormData({
        status: stageData.status || 'pending',
        notes: stageData.notes || '',
      });
    }
  }, [stageData]);

  const statusOptions = [
    { value: 'pending', label: 'Pending' },
    { value: 'in-progress', label: 'In Progress' },
    { value: 'completed', label: 'Completed' },
  ];

  const handleSubmit = async () => {
    try {
      // API call to update the specific stage in the batch
      await axios.put(`${config.API_BASE_URL}/production-batches/${batchId}/stages/${stageData._id}`, {
        status: formData.status,
        notes: formData.notes,
      });

      refreshBatch();
      handleClose();
    } catch (error) {
      console.error('Failed to update stage:', error);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Update Stage: {stageData?.stageName || 'Stage'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Status</Form.Label>
            <Form.Select
              value={formData.status}
              onChange={(e) => setFormData({ ...formData, status: e.target.value })}
            >
              {statusOptions.map(({ value, label }) => (
                <option key={value} value={value}>{label}</option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group>
            <Form.Label>Notes</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              value={formData.notes}
              onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
              placeholder="Add any notes about this stage..."
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>Cancel</Button>
        <Button variant="primary" onClick={handleSubmit}>Save Changes</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default StageUpdateModal;
